import type { KanbanComment } from '@entities/kanban-comment'

import { useKanbanCommentsStore } from '@entities/kanban-comment'
import { useCommonStore } from '@shared/model'
import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface TasksKanbanCommentsApiOptions {
  taskId: string | number
  onStart?: () => void
  onSuccess?: (data: KanbanComment[]) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useTasksKanbanCommentsApi = async (options: TasksKanbanCommentsApiOptions): Promise<KanbanComment[]> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.kanban-tasks.comments', { task_id: options.taskId })

  const kanbanCommentsStore = useKanbanCommentsStore()
  const commonStore = useCommonStore()

  options.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const comments: KanbanComment[] = data.data

    kanbanCommentsStore.setComments(comments)
    commonStore.setLoading(false)

    options.onSuccess?.(comments)

    return comments
  } catch (err: unknown) {
    console.error(err)
    toast.error(getAxiosErrorMessage(err))
    commonStore.setLoading(false)
    options.onError?.(err)

    return []
  } finally {
    options.onFinish?.()
  }
}